export { default } from './Toolbar';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Toolbar/index.js
// module id = 1084
// module chunks = 0